"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import { ApiPageSortDirection } from "@/generated/models/ApiPageSortDirection";
import { fetchWavePollsV2 } from "@/services/api/wave-drops-v2-api";
import { useQuery } from "@tanstack/react-query";
const WAVE_POLLS_AVAILABILITY_PAGE_SIZE = 1;
interface UseWaveHasPollsProps {
  readonly waveId: string | null | undefined;
  readonly enabled?: boolean | undefined;
}
export function useWaveHasPolls(t0) {
  const $ = _c(11);
  const {
    waveId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== waveId) {
    t2 = waveId?.trim() ?? "";
    $[0] = waveId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedWaveId = t2;
  const isEnabled = enabled && normalizedWaveId.length > 0;
  let t3;
  if ($[2] !== normalizedWaveId) {
    t3 = [QueryKey.WAVE_POLLS, {
      scope: "has-polls",
      waveId: normalizedWaveId,
      pageSize: WAVE_POLLS_AVAILABILITY_PAGE_SIZE,
      sortDirection: ApiPageSortDirection.Desc,
      sort: "created_at"
    }];
    $[2] = normalizedWaveId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = t3 as const;
  let t5;
  if ($[4] !== normalizedWaveId) {
    t5 = async t6 => {
      const {
        signal
      } = t6;
      const pollsPage = await fetchWavePollsV2({
        waveId: normalizedWaveId,
        page: 1,
        pageSize: WAVE_POLLS_AVAILABILITY_PAGE_SIZE,
        sortDirection: ApiPageSortDirection.Desc,
        sort: "created_at",
        signal
      });
      return pollsPage.count > 0 || pollsPage.data.length > 0;
    };
    $[4] = normalizedWaveId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getDefaultQueryRetry();
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isEnabled || $[8] !== t4 || $[9] !== t5) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: isEnabled,
      staleTime: 60000,
      ...t6
    };
    $[7] = isEnabled;
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const {
    data
  } = useQuery(t7);
  return data === true;
}